/*
 * @Author: chengyu
 * @Date: 2022-08-16 20:46:00
 * @Description: 通用部分
 */
export var MpTypeEnum;
(function (MpTypeEnum) {
    MpTypeEnum["taro"] = "taro";
    MpTypeEnum["alipay"] = "alipay";
    MpTypeEnum["wechat"] = "wechat";
    MpTypeEnum["browser"] = "browser";
})(MpTypeEnum || (MpTypeEnum = {}));
export var StorageTypeEnum;
(function (StorageTypeEnum) {
    StorageTypeEnum["GET"] = "get";
    StorageTypeEnum["SET"] = "set";
    StorageTypeEnum["REMOVE"] = "remove";
})(StorageTypeEnum || (StorageTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3JlL2Jhc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUVILE1BQU0sQ0FBTixJQUFZLFVBS1g7QUFMRCxXQUFZLFVBQVU7SUFDcEIsMkJBQWEsQ0FBQTtJQUNiLCtCQUFpQixDQUFBO0lBQ2pCLCtCQUFpQixDQUFBO0lBQ2pCLGlDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFMVyxVQUFVLEtBQVYsVUFBVSxRQUtyQjtBQUVELE1BQU0sQ0FBTixJQUFZLGVBSVg7QUFKRCxXQUFZLGVBQWU7SUFDekIsOEJBQVcsQ0FBQTtJQUNYLDhCQUFXLENBQUE7SUFDWCxvQ0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSlcsZUFBZSxLQUFmLGVBQWUsUUFJMUIifQ==